import { ReactNode, useState } from 'react';
import { ChevronDown } from '../../../../../components/icons';

interface Props {
  children: ReactNode;
  title: string;
}

function FilterSection(props: Props) {
  const [closed, setClosed] = useState(false);

  return (
    <div className="py-6 space-y-2">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setClosed((prev) => !prev)}
      >
        <h6 className="font-bold text-lg tracking-tighter text-greyscale-label m-0 p-0">
          {props.title}
        </h6>
        <ChevronDown
          className={`text-greyscale-label transition ease-in-out duration-200 ${
            closed ? 'rotate-180' : ''
          }`}
        />
      </div>
      {!closed && <div>{props.children}</div>}
    </div>
  );
}

export default FilterSection;
